
export const parseDataFromLocalStorage = (data) => {
    let output = null;

    try {
        output = JSON.parse(data, (key, value) => {
            if (typeof value === 'string') {
                let isDate = /(\d{4})-(\d{2})-(\d{2})T((\d{2}):(\d{2}):(\d{2}))\.(\d{3})Z/.test(value);
                if (isDate) {
                    return new Date(value);
                }
            }
            return value;
        });
    }
    catch(err) {
        console.error(err);
        console.error("error while parsing LocalStorage State: ", data);
    }

    return output;
}



// WEBPACK FOOTER //
// ./src/storeState/persistence/helper.js